import React from 'react';
import type { YAxisProps } from 'recharts';

const LeftAlignedYAxisTick: YAxisProps['tick'] = (props) => {
    const { y, payload, style, className, tickFormatter } = props;
    return (
        <g>
            <text x={0} y={6 + y} textAnchor="start" fill="#666" style={style} className={className}>
                {tickFormatter ? tickFormatter(payload.value) : payload.value}
            </text>
        </g>
    );
};

export default LeftAlignedYAxisTick;
